$(() => {
  if (window.matchMedia('(max-width: 768px)').matches) {
    $('[data-replace-placeholder]').each(function () {
      $(this).attr('placeholder', $(this).data('replace-placeholder'));
    })
  }
});
